import React from 'react';
import PropTypes from 'prop-types';
import connect from './connect';
import { Row, Col, Button, Alert} from 'react-bootstrap';
import Select from 'react-select';
import { DropTarget, DragSource, DragDropContext } from 'react-dnd';
import HTML5Backend from 'react-dnd-html5-backend';
import { findDOMNode } from 'react-dom';
import { copy } from 'utils';
import classNames from 'classnames';
import * as Api from 'api';
import PageSelector from './page-selector';
const ItemTypes = {
  MENU_ITEM: 'MENU_ITEM'
}

const menuSource = {
  beginDrag(props) {
    return {
      id: props.id,
      index: props.index
    }
  }
}

const lessThan = (array1, array2) => {

  if(typeof array1 === 'number') {
    array1 = [array1];
  }
  if(typeof array2 === 'number') {
    array2 = [array2]
  }

  let index = 0;
  let finalCondition = Math.min(array1.length, array2.length);
  while(index < finalCondition) {
    //Go down the array until you find two elements that are not equal.
    if(array1[index] < array2[index]) {
      return true;
    }
    if(array1[index] > array2[index]) {
      return false;
    }
    //Find out which array is larger if the arrays are not equal.
    if(index == finalCondition - 1) {
      return array1.length < array2.length;
    }
    index++;
  }
}

const greaterThan = (array1, array2) => lessThan(array2, array1);

const menuTarget = {
  hover(props, monitor, component) {
    const dragIndex = monitor.getItem().index;
    const hoverIndex = props.index;
    const dragID = monitor.getItem().id;
    const hoverID = props.id;

    if(dragID === hoverID) {
      return;
    }

    // Determine rectangle on screen
		const hoverBoundingRect = findDOMNode(component).getBoundingClientRect()

		// Get vertical middle
		const hoverMiddleY = (hoverBoundingRect.bottom - hoverBoundingRect.top) / 2

		// Determine mouse position
		const clientOffset = monitor.getClientOffset()

		// Get pixels to the top
		const hoverClientY = clientOffset.y - hoverBoundingRect.top

		// Only perform the move when the mouse has crossed half of the items height
		// When dragging downwards, only move when the cursor is below 50%
		// When dragging upwards, only move when the cursor is above 50%

		// Dragging downwards
		if (lessThan(dragIndex, hoverIndex) && hoverClientY < hoverMiddleY) {
			return
		}

		// Dragging upwards
		if (greaterThan(dragIndex, hoverIndex) && hoverClientY > hoverMiddleY) {
			return
		}

		// Time to actually perform the action
		props.moveItem(dragIndex, hoverIndex)

		// Note: we're mutating the monitor item here!
		// Generally it's better to avoid mutations,
		// but it's good here for the sake of performance
		// to avoid expensive index searches.

		monitor.getItem().index = hoverIndex
  }
}

@DropTarget(ItemTypes.MENU_ITEM, menuTarget, (connect, monitor) => ({
  connectDropTarget: connect.dropTarget(),
  isOver: monitor.isOver()
}))
@DragSource(ItemTypes.MENU_ITEM, menuSource, (connect, monitor) => ({
  connectDragSource: connect.dragSource(),
  isDragging: monitor.isDragging(),
}))
class Item extends React.Component {
  static propTypes = {
    connectDragSource: PropTypes.func.isRequired,
		connectDropTarget: PropTypes.func.isRequired,
		index: PropTypes.number.isRequired,
		isDragging: PropTypes.bool.isRequired,
		id: PropTypes.any.isRequired,
		moveItem: PropTypes.func.isRequired,
    title: PropTypes.string.isRequired,
    path: PropTypes.string.isRequired,
    isOver: PropTypes.bool.isRequired,
  }
  constructor(props) {
    super(props);

    this.state = {
      dirty: false,
      editing: false,
      menu_item: {
        _id: props._id || '',
        title: props.title || '',
        path: props.path || '',
      }
    };

    this.handleSave = this.handleSave.bind(this);
    this.setEditMode = this.setEditMode.bind(this);
    this.handleCancel = this.handleCancel.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.startCreatingItem = this.startCreatingItem.bind(this);
    this.startDeletingItem = this.startDeletingItem.bind(this);
  }
  setEditMode(booly) {
    this.setState({ editing: booly });
  }
  handleChange(path, value) {
    const { menu_item } = this.state;

    this.setState({
      dirty: true,
      menu_item: {
        ...menu_item,
        [path]: value
      }
    });
  }
  handleSave() {
    if(this.props.onSave) {
      this.props.onSave(this.state.menu_item);
    }
    this.setState({ dirty: false, editing: false });
  }
  handleCancel() {
    if(this.props.onCancel) {
      this.props.onCancel();
    }
    this.setState({
      dirty: false,
      editing: false
    })
  }
  handleAddChild() {
    if(this.props.addChild) {
      this.props.addChild(this.state.menu_item);
    }
  }
  startCreatingItem(parent) {
    if(this.props.addButtonClicked) {
      this.props.addButtonClicked(parent);
    }
  }
  startDeletingItem(index, item) {
    if(this.props.deleteButtonClicked) {
      this.props.deleteButtonClicked(index, item);
    }
  }
  render() {
    const {
      editing,
      menu_item,
    } = this.state;
    const {
      connectDragSource,
      connectDropTarget,
      isDragging,
      children,
      index,
      isOver,
    } = this.props;

    const {
      _id,
    } = menu_item;
    const { path, title, uri, type, allowDelete, page } = this.props;
    const opacity = isDragging ? 0 : 1;

    return connectDragSource(
      <div className='__settings-item-container' style={{ opacity }}>

        {connectDropTarget(
        <div>
          <div className='__settings-item'>


            {title && <span className='setting title'>{title}</span> || null}
            {path && <span className='setting path'><i className='fa fa-link'></i> {path[0] != '/' && '/' || null}{path}  </span> || null}
            {type == 'REDIRECT' ? <span className='setting type'>Redirect</span> : null}
            {uri ? <span className='setting uri'><i className='fa fa-link'></i> {uri}</span> : null}
            {type == 'PAGE' ? <span className='setting type'>Page - {page ? <span className='setting page'><PageSelector value={page} readOnly /></span> : '(none selected)'}</span> : null}

            {editing && <span onClick={e => {
              e.stopPropagation();
              this.handleSave();
            }} className='btn btn-xs btn-primary btn-inline'>Save</span> || null}
            {editing && <span onClick={e => {
              e.stopPropagation();
              this.setEditMode(false);
            }} className='btn btn-xs btn-default btn-inline'>Cancel</span> || null}
            <div className='__settings-delete'>
              {allowDelete? (
                <a href='#' onClick={e => {
                  e.preventDefault();
                  e.stopPropagation();
                  this.startDeletingItem(index, menu_item);
                }}><i className='fa fa-trash'></i></a>
              ) : null}
            </div>
            <div className='__settings-create'>
              <a href='#' onClick={e => {
                e.preventDefault();
                e.stopPropagation();
                this.startCreatingItem(index, menu_item);
              }}><i className='fa fa-plus'></i></a>
            </div>
          </div>
        </div>
        )}
        {children ? (
          <div className="__settings-children">
            {children}
          </div>
        ) : null}
      </div>
    )
  }
}



@DragDropContext(HTML5Backend)
class MenuSettings extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      dirty: false,
      selected_menu: 'main_menu',
      menuItems: [
        { _id:1, title: 'A', path: '/abc1', children: [
          { _id: 4, title: 'SubA', path: '/suba' },
          { _id: 5, title: 'SubB', path: '/subb' },
          { _id: 6, title: 'SubB', path: '/subc' },
        ] },
        { _id:2, title: 'B', path: '/abc2' },
        { _id:3, title: 'C', path: '/abc3' },
      ]
    }

    this.moveItem = this.moveItem.bind(this);
    this.isNotValid = this.isNotValid.bind(this);
    this.selectMenu = this.selectMenu.bind(this);
    this.handleSaveItem = this.handleSaveItem.bind(this);
    this.handleSaveMenu = this.handleSaveMenu.bind(this);
    this.handleChangeTMP = this.handleChangeTMP.bind(this);
    this.startDeletingItem = this.startDeletingItem.bind(this);
    this.cancelDeletingItem = this.cancelDeletingItem.bind(this);
    this.startAddingChildToParent = this.startAddingChildToParent.bind(this);
    this.cancelAddingChildToParent = this.cancelAddingChildToParent.bind(this);
  }
  isNotValid(path, value) {
    switch(path) {
      case 'title': {
        return !value.length > 0 ?
          'You must provide a valid title.' : false;
      }
      case 'path': {
        return value.length == 0 || !value.match(/^((-|_|[a-z]|[0-9])*\/?)*$/gi) ?
          'You must provide a valid path in the form /some/path/name.' : false;
      }
      case 'type': {
        return value !== 'PAGE' && value !== 'REDIRECT' ?
          'You must provide a valid menu item type.' : false;
      }
      default: {
        return false;
      }
    }
  }
  handleChangeTMP(path, value) {
    switch(path) {
      case 'path': {
        if(value[0] !== '/') value = `/${value}`;
      }
    }
    this.setState({
      tmp_item: {
        ...this.state.tmp_item,
        [path]: value
      },
      tmp_validation: {
        ...this.state.tmp_validation,
        [path]: this.isNotValid(path, value)
      },
      tmp_dirty: true
    });
  }
  handleSaveItem() {
    const { tmp_item, creating_item_parent_index } = this.state;
    const menu = copy(this.state.menus.find(item => item._id == this.state.tmp_item.menu));
    const isCreatingNew = tmp_item._id ? false: true;
    const save = !isCreatingNew ? Api.updateMenuItem : Api.createMenuItem;

    this.setState({ saving: true });

    save(this.state.tmp_item).then(item => {
      if(!menu.order) menu.order = [];
      if(isCreatingNew) {
        this.addMenuItem(
          typeof creating_item_parent_index === 'undefined' ?
          [0] : typeof creating_item_parent_index === 'number' ?
            [ creating_item_parent_index, 0 ] :
            [ ...creating_item_parent_index, 0 ],
          item,
          menu.order
        );
      } else {
        this.setMenuItem(creating_item_parent_index, item, menu.order);
      }
      return Api.updateMenu({ _id: this.state.tmp_item.menu, order: menu.order }).then(savedMenu => {
        if(!this.mounted) return;
        this.setState({
          tmp_item: null,
          tmp_validation: null,
          creating_item: false,
          creating_item_parent_index: null,
          saving: false,
          dirty: false,
          menus: [...this.state.menus.filter(item => item._id != menu._id), menu]
        })
      });
    }).catch(error => {
      if(!this.mounted) return;
      this.setState({ saving: false, error });
    });

  }
  handleSaveMenu() {
    this.setState({ saving_menu: true });
    const menu = copy(this.state.menus.find(item => item._id == this.state.selected_menu));
    Api.updateMenu({ _id: this.state.selected_menu, order: menu.order }).then(response => {
      if(!this.mounted) return;
      this.setState({ dirty: false, saving_menu: false });
    }).catch(error => {
      if(!this.mounted) return;
      this.setState({ saving_menu: false, error });
    });
  }
  startAddingChildToParent(index) {
    this.setState({
      tmp_item: { menu: this.state.selected_menu, title: '', path: '', type: 'PAGE', redirect_uri: '' },
      tmp_validation: {},
      tmp_dirty: false,
      creating_item: true,
      creating_item_parent_index: index
    });
  }
  cancelAddingChildToParent() {
    this.setState({
      tmp_item: null,
      tmp_validation: null,
      creating_item: false,
      creating_item_parent_index: null
    });
  }
  startDeletingItem(index, item) {
    this.setState({
      deleting_item: item,
      deleting_index: index,
    });
  }
  cancelDeletingItem() {
    this.setState({ deleting_item: null, deleting_index: null });
  }
  confirmDeletingItem() {
    this.setState({ deleting: true });
    const { deleting_index } = this.state;
    const menu = this.state.menus.find(menu => menu._id == this.state.deleting_item.menu);
    this.deleteMenuItem(typeof deleting_index === 'number' ? [deleting_index] : deleting_index, menu.order);
    Api.updateMenu({ _id: this.state.deleting_item.menu, order: menu.order }).then(savedMenu => {
      return Api.deleteMenuItem(this.state.deleting_item._id);
    }).then(message => {
      this.setState({ deleting: false, deleting_item: null, deleting_index: null });
    }).catch(error => {
      if(!this.mounted) return;
      this.setState({ deleting: false, error });
    })
  }
  getMenuItem(indexPath, array) {
    if(indexPath.length == 1) {
      return array[indexPath[0]];
    }
    else {
      const selectedArrayItem = array[indexPath.shift()];
      if(!selectedArrayItem.children) selectedArrayItem.children = [];
      return this.getMenuItem(indexPath, selectedArrayItem.children);
    }
  }
  setMenuItem(indexPath, item, array) {
    if(indexPath.length == 1) {
      array.splice(indexPath[0], 0, item);
      return array;
    }
    else {
      const selectedArrayItem = array[indexPath.shift()];
      if(!selectedArrayItem.children) selectedArrayItem.children = [];
      return this.setMenuItem(indexPath, item, selectedArrayItem.children);
    }
  }
  addMenuItem(indexPath, item, array) {
    if(indexPath.length == 1) {
      array.splice(indexPath[0], 0, item);
    } else {
      const selectedArrayItem = array[indexPath.shift()];
      if(!selectedArrayItem.children) selectedArrayItem.children = [];
      return this.addMenuItem(indexPath, item, selectedArrayItem.children);
    }
  }
  deleteMenuItem(indexPath, array) {

    if(indexPath.length == 1) {
      array.splice(indexPath[0], 1);
    }
    else {
      const selectedArrayItem = array[indexPath.shift()];
      if(!selectedArrayItem.children) selectedArrayItem.children = [];
      return this.deleteMenuItem(indexPath, selectedArrayItem.children);
    }
  }
  selectMenu(selected_menu) {
    this.setState({ selected_menu });
  }
  moveItem(dragIndex, hoverIndex) {
    if(this.logTimer) clearTimeout(this.logTimer);
    this.logTimer = setTimeout(() => console.log(dragIndex, hoverIndex), 100);
    const menuItems = copy((((this.state.menus || []).find(menu => menu._id == this.state.selected_menu) || {}).order || []));
    const dragItem = this.getMenuItem(copy(typeof dragIndex === 'number' ? [dragIndex]: dragIndex), menuItems);
    this.deleteMenuItem(copy(typeof dragIndex === 'number'? [dragIndex]: dragIndex), menuItems);
    this.setMenuItem(copy(typeof hoverIndex === 'number'? [hoverIndex]: hoverIndex), dragItem, menuItems);
    this.setState({
      dirty: true,
      menus: [
        ...this.state.menus.filter(menu => menu._id !== this.state.selected_menu),
        {
          ...this.state.menus.find(menu => menu._id == this.state.selected_menu),
          order: menuItems
        }
      ]
    });
  }
  componentWillUnmount() {
    this.mounted = false;
  }
  componentWillMount() {
    this.mounted = true;
  }
  populateItem(item, menu) {
    for (var i = 0; i < menu.length; i++) {
      if(menu[i]._id == item._id) {
        Object.assign(menu[i], item);
      }
      if(!menu[i].children) menu[i].children = [];
      this.populateItem(item, menu[i].children);
    }
  }
  componentDidMount() {
    Api.fetchMenus({}).then(data => {
      if(!this.mounted) return;
      if(!data.results.find(item => item.title != 'Main Menu')) {
        Api.createMenu({
          title: 'Main Menu',
        }).then(menu => {
          if(!this.mounted) return;
          this.setState({
            menus: [...(this.state.menus || []), menu]
          });
        })
      }
      if(!data.results.find(item => item.title != 'Footer Menu')) {
        Api.createMenu({
          title: 'Footer Menu',
        }).then(menu => {
          if(!this.mounted) return;
          this.setState({
            menus: [...(this.state.menus || []), menu]
          });
        })
      }

      this.setState({
        selected_menu: (data.results.find(item => item.title == 'Main Menu') || {})._id,
        menus: data.results
      })
    })
    .catch(error => {
      if(!this.mounted) return;
      this.setState({
        error
      });
    });
  }
  render() {
    const { menuItems, creating_item, deleting_item, tmp_item, tmp_validation, tmp_dirty, dirty, selected_menu } = this.state;
    const menu_items = (((this.state.menus || []).find(menu => menu._id == selected_menu) || {}).order || []);

    const renderTree = (item, idx) => (
      <div>
        <Item
          key={item._id}
          index={idx}
          id={item._id}
          {...item}
          allowDelete={!item.children || item.children.length == 0}
          moveItem={this.moveItem}
          addButtonClicked={e => this.startAddingChildToParent(idx)}
          deleteButtonClicked={e => this.startDeletingItem(idx, item)}
        >
          {deleting_item && deleting_item._id == item._id && (
            <div className='__confirm-delete'>
              <Alert>
                {!this.state.deleting ? <div>
                  <p>Are you sure?</p>
                  <Button onClick={e => this.confirmDeletingItem()} bsStyle={'warning'}>Yes</Button>
                  <Button onClick={e => this.cancelDeletingItem()}  bsStyle={'danger'}>No</Button>
                </div> : (
                  <i className='fa fa-spin fa-spinner'></i>
                )}
              </Alert>
            </div>
          ) || null}
          {item.children && item.children.map((item, idx2) => renderTree(
            item,
            typeof idx === 'number' && [idx, idx2] || [ ...idx, idx2 ]
          )) || null}
        </Item>
      </div>
    );

    if(creating_item) {
      const validation_keys = Object.keys(tmp_validation || {});
      const isValid = tmp_dirty && !validation_keys.find(key => tmp_validation[key]);

      return (
        <Row>
          <Col xs={12}>
            {this.state.error ? <Alert bsStyle={'danger'}>
              {this.state.error.message}
            </Alert> : null}
          </Col>
          <Col xs={12}>
            <h1 className='mt-none'>Create Menu Item</h1>
            <div className={
              `form-group${
                tmp_validation ?
                  tmp_validation['type'] ?
                    ' has-error' :
                    typeof tmp_validation['type'] !== 'undefined' && ' has-success' || ''
                : ''}`
            }>
              <label className='form-label'>Type</label>
              <Select
                placeholder='Pick menu item type.'
                options={[
                  { label: 'Page', value: 'PAGE' },
                  { label: 'Redirect', value: 'REDIRECT'}
                ]}
                value={tmp_item.type}
                onChange={option => this.handleChangeTMP('type', option.value)}
              />
            </div>
            <div className={
              `form-group${
                tmp_validation ?
                  tmp_validation['title'] ?
                    ' has-error' :
                    typeof tmp_validation['title'] !== 'undefined' && ' has-success' || ''
                : ''}`
              }>
              <label className='form-label'>Title</label>
              <input
                onChange={e => this.handleChangeTMP('title', e.target.value)}
                type='text'
                className={'form-control'}
                placeholder='Title'
                value={tmp_item.title}
              />
            </div>
            <div className={
              `form-group${
                tmp_validation ?
                  tmp_validation['path'] ?
                    ' has-error' :
                    typeof tmp_validation['path'] !== 'undefined' && ' has-success' || '' : ''}`}>
              <label className='form-label'>Path</label>
              <input
                onChange={e => this.handleChangeTMP('path', e.target.value)}
                type='text'
                className={`form-control`}
                placeholder='Path'
                value={tmp_item.path}
              />
            </div>
            {tmp_item.type == 'PAGE' && <div className={'form-group'}>
              <label className='form-label'>Page</label>
              <PageSelector
                value={tmp_item.page}
                onChange={option => this.handleChangeTMP('page', option && option.value || '')}
              />
            </div> || null}
            {tmp_item.type == 'REDIRECT' && <div className={
              `form-group${
                tmp_validation ?
                  tmp_validation['redirect_uri'] ?
                    ' has-error' :
                    typeof tmp_validation['redirect_uri'] !== 'undefined' && ' has-success' || '' : ''}`}>
              <label className='form-label'>Redirect Uri</label>
              <input
                onChange={e => this.handleChangeTMP('redirect_uri', e.target.value)}
                type='text'
                className={`form-control`}
                placeholder='Redirect Uri'
                value={tmp_item.redirect_uri}
              />
            </div> || null}
          </Col>
          <Col xs={12}>
            <hr className='divider' />
          </Col>
          <Col xs={12} md={6}>
            {validation_keys.length > 0 && !isValid && (
              <Alert bsStyle='warning'>
                <ul>
                  {validation_keys.map(key => tmp_validation[key] && <li>{tmp_validation[key]}</li> || null)}
                </ul>
              </Alert>
            ) || null}
          </Col>
          <Col xs={12} md={6}>
            <Row>
              <Col xs={6}>
                <Button onClick={e => this.cancelAddingChildToParent()} block bsStyle={'default'}>
                  Cancel
                </Button>
              </Col>
              <Col xs={6}>
                <Button disabled={!isValid} onClick={e => isValid && this.handleSaveItem()} block bsStyle={'primary'}>
                  Create
                </Button>
              </Col>
            </Row>
          </Col>
        </Row>
      );
    }
    return (
      <Row>
        <Col xs={12} style={{ marginBottom: '10px' }}>
          <Select
            placeholder={'Select a menu to edit.'}
            options={(this.state.menus || []).map(menu => ({
              label: menu.title,
              value: menu._id
            }))}
            value={this.state.selected_menu}
            onChange={(option) => this.selectMenu(option && option.value || '' )}
          />
        </Col>
        <Col xs={12}>
          {menu_items.length == 0 && (
            <div>
              <span>No menu items created. </span>
            </div>
          ) || menu_items.map((item, idx) => renderTree(item, idx))}
          <a onClick={e => {
            e.preventDefault();
            this.startAddingChildToParent();
          }}><i className='fa fa-plus'></i> Add</a>
          {dirty && <Row>
            <Col xs={12} md={8}></Col>
            <Col xs={12} md={4}>
              {this.state.saving_menu ? (
                <Row>
                  <Col xs={12}><i className='fa fa-spinner fa-spin'></i></Col>
                </Row>
              ) : (
                <Row>
                  <Col xs={6}><Button block bsStyle={'default'}>Cancel</Button></Col>
                  <Col xs={6}><Button onClick={e => this.handleSaveMenu()} block bsStyle={'primary'}>Save</Button></Col>
                </Row>
              )}
            </Col>
          </Row> || null}
        </Col>
      </Row>
    );
  }

}

export default connect(MenuSettings);



// WEBPACK FOOTER //
// ./src/browser/components/sales-site-manager/menu-settings.js